import { VENDOR_RESEND_OTP, VENDOR_RESEND_OTP_SUCCESS, VENDOR_RESEND_OTP_ERROR, VENDOR_RESEND_OTP_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const VendorResendOtp = (state = initialState, action) => {
  switch (action.type) {
    case VENDOR_RESEND_OTP:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case VENDOR_RESEND_OTP_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case VENDOR_RESEND_OTP_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case VENDOR_RESEND_OTP_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default VendorResendOtp;
